module.exports = __webpack_public_path__ + "static/media/elephant.66d83dcc.png";